






































































































import TextLabel from "@/common/components/atoms/TextLabel.vue";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";
import PointNotation from "@/common/components/atoms/PointNotation.vue";
import { Prop, Component, Vue } from "vue-property-decorator";
import commons from "@/common/store/modules/commons";
import globals from "@/general/store/modules/globals";
import TheC01ItemFormNotePanelShortage from "@/general/components/pages/parts/ProductDetails/TheC01ItemFormNotePanelShortage.vue";
import TheC01ItemFormNotePanelDrink from "@/general/components/pages/parts/ProductDetails/TheC01ItemFormNotePanelDrink.vue";
import TheC01ItemFormNotePanelGiftCard from "@/general/components/pages/parts/ProductDetails/TheC01ItemFormNotePanelGiftCard.vue";
import {
  getShoppingCartItems,
  postShoppingCartItems
} from "@/general/store/api";
import { ShoppingCartItemRequest } from "gen/ricapi/api";
import ItemSpecs from "@/general/components/molecules/ItemSpecs.vue";
import LocalStorage from "@/general/utils/storage";

@Component({
  components: {
    TextLabel,
    ButtonMain,
    PointNotation,
    TheC01ItemFormNotePanelShortage,
    TheC01ItemFormNotePanelDrink,
    TheC01ItemFormNotePanelGiftCard,
    ItemSpecs
  }
})
export default class ItemListPanelLarge extends Vue {
  @Prop({ type: Array, required: false, default: () => [] }) thumbnails!: any;
  @Prop({ type: String, required: false, default: "" }) status!: string;
  @Prop({ type: String, required: false, default: "" }) name!: string;
  @Prop({ type: Number, required: false, default: "" }) id!: number;
  @Prop({ type: Number, required: false, default: "" }) premiumId!: number;
  @Prop({ type: Number, required: false, default: "" }) point!: number;
  @Prop({ type: Number, required: false, default: "" })
  usedPointsAfterAddToCart!: number;
  @Prop({ type: Number, required: false, default: "" }) discountRate!: number;
  @Prop({ type: Boolean, required: false, default: false }) isCart!: boolean;
  @Prop({ type: Boolean, required: false, default: false })
  supplierCreditcard!: boolean;
  @Prop({ type: Number, required: true, default: 0 }) stock!: any;
  @Prop({ type: Boolean, required: true, default: false })
  stockControl!: boolean;

  @Prop({ type: String, required: true, default: "normal" }) type!: any;
  @Prop({ type: String, required: true }) color!: any;
  @Prop({
    type: Array,
    required: false,
    default: () => {
      [];
    }
  })
  options!: any;

  @Prop({ type: Boolean, required: true }) ageAlert!: boolean;
  @Prop({ type: String, required: true }) page!: string;

  creditCardEnabled = false;
  count = 1;

  isAdult = false;
  cartItem: any = [];

  // get colorCode() {
  //   return this.stock > 0 ? commons.colorCode : "#333";
  // }

  get showSpecs() {
    return this.page === "favorite";
  }

  get unit() {
    return commons.OrgPageSpecific?.point_name;
  }
  get isSp() {
    return globals.isSpScreenWidth;
  }
  get itemPointFontSize() {
    return this.isSp ? 28 : 24;
  }
  emitDelete() {
    this.$emit("delete");
  }

  get hasStock() {
    return this.stock > 0;
  }

  get productRequiredpoints() {
    return this.point * 1;
  }

  get userPointsAreGreaterThanProductPoint() {
    const userPoints = this.possession;
    const productRequiredpoints = this.productRequiredpoints;
    return userPoints >= productRequiredpoints;
  }

  get possession() {
    const userPoints = LocalStorage.getItem("userPointsDetails")
      ? JSON.parse(LocalStorage.getItem("userPointsDetails") as string)
      : "";

    if (userPoints !== "") {
      return (
        userPoints.total_points -
        userPoints.thanks_exclusive_points -
        this.usedPointsAfterAddToCart
      );
    } else {
      return 0;
    }
  }

  get isGiftCardAndNormalItemInCart() {
    const isGiftCard = this.type === "gift_card";

    const hasNormalItemInCart = this.cartItem.some(
      (item: any) => item.sku_data.redemption_type === 1
    );
    return (
      isGiftCard && hasNormalItemInCart && this.stock > 0 && this.possession > 0
    );
  }
  get isNormalItemAndGiftCardInCart() {
    const isNormalItem = this.type === "normal";
    const hasGiftCardInCart = this.cartItem.some(
      (item: any) => item.sku_data.redemption_type !== 1
    );
    return (
      isNormalItem && hasGiftCardInCart && this.stock > 0 && this.possession > 0
    );
  }

  get cartItemCount() {
    return parseInt(LocalStorage.getItem("cartItemCount") as string);
  }

  get cartEmpty() {
    return this.cartItemCount == 0;
  }

  async created() {
    const cartItems = await getShoppingCartItems(1, 90, "");

    LocalStorage.setItem("cartDetails", JSON.stringify(cartItems?.results));
    this.cartItem = cartItems?.results;

    const skuIds: any = [];
    cartItems.results?.forEach((item) => {
      skuIds.push(item?.sku_id);
    });

    LocalStorage.setItem("cartSkuIds", JSON.stringify(skuIds));
    const creditCardEnabled = this.creditCardEnabledAdmin;
    if (creditCardEnabled === 0 && this.supplierCreditcard) {
      this.creditCardEnabled = creditCardEnabled;
    }
  }

  get disabled() {
    if (this.hasStock) {
      if (this.possession >= this.productRequiredpoints) {
        //credit card not required
        if (this.cartItemCount > 0) {
          if (
            this.isGiftCardAndNormalItemInCart ||
            this.isNormalItemAndGiftCardInCart
          ) {
            console.log("gift and normal condition failed");
            return true;
          } else {
            console.log("gift and normal condition passed");
            return false;
          }
        } else {
          console.log(" cart is empty");
          return false;
        }
      } else {
        if (this.possession < 1) {
          console.log("user points are 0");
          return true;
        }
        //credit required
        if (this.creditCardEnabled) {
          if (this.cartItemCount > 0 || this.count != 1) {
            console.log(
              "credit card not allowed because cart is not empty or count is not equal to 1 "
            );
            return true;
          } else {
            if (this.type !== "gift_card") {
              console.log("credit card allowed because cart is empty");
              return false;
            } else {
              console.log("credit card allowed because product is gift card");
              return true;
            }
          }
        } else {
          console.log("credit card is disabled");
          return true;
        }
      }
    } else {
      console.log("No stock Available");
      return true;
    }
  }

  get setOpacity() {
    if (!this.stockControl) {
      return { opacity: 1, "vertical-align": "baseline" };
    }
    if (!this.stock) {
      return { opacity: 0.3, "vertical-align": "baseline" };
    }
    return false;
  }

  async addToCart() {
    const userDetails = JSON.parse(
      LocalStorage.getItem("userDetails") as string
    );
    const shoppingCartItemRequest: ShoppingCartItemRequest = {
      user: userDetails.id,
      sku_id: this.id,
      quantity: this.count
    };
    const response = await postShoppingCartItems(shoppingCartItemRequest);
    if (response) {
      window.location.href = "/cart-details";
    }
  }

  getSpecs(options: any) {
    const specs = options.map((item: any) => {
      return { term: item.option_type_name, description: item.value };
    });

    return specs;
  }

  get creditCardEnabledAdmin() {
    // const orgAdminSettings = LocalStorage.getItem("orgAdminSettings")
    //   ? JSON.parse(LocalStorage.getItem("orgAdminSettings") as string)
    //   : [];

    // return orgAdminSettings[0].self_pay_enabled;

    const userDetails = LocalStorage.getItem("userDetails");
    if (userDetails) {
      const userDetailsJson = JSON.parse(userDetails);
      return userDetailsJson.self_pay_enabled;
    }
    return false;
  }
}
